/* global globalThis */
const local = globalThis.localStorage;
export default local;
